import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import cn from 'classnames';

import { Icon } from 'components';

import warningGlyph from 'assets/svg/warning.svg';
import './betslipModal.scss';

interface Props {
    handleClick: VoidFn;
    handleCancel: VoidFn;
    handleSubmit: VoidFn;
    title: MessageDescriptor;
    subTitle?: MessageDescriptor;
    message: MessageDescriptor;
    cancelTextBtn: MessageDescriptor;
    submitTextBtn: MessageDescriptor;
    subTextBtn: MessageDescriptor;
    iconMessage?:
        | {
              id: string;
              content: string;
              viewBox: string;
          }
        | undefined;
    balance?: string;
    stake?: string;
    isStakeBtn?: boolean;
}

const BetslipModal: React.FC<Props> = ({
    handleClick,
    handleSubmit,
    handleCancel,
    title,
    subTitle,
    message,
    cancelTextBtn,
    submitTextBtn,
    subTextBtn,
    iconMessage,
    balance,
    stake,
    isStakeBtn,
}) => {
    return (
        <div styleName="wrapper">
            <div styleName="container">
                <div
                    styleName={cn('header', {
                        'is-invisible': !subTitle,
                    })}
                >
                    <div styleName="title">
                        <Icon glyph={warningGlyph} />
                        <FormattedMessage {...title} />
                    </div>
                    {subTitle && (
                        <div styleName="sub-title">
                            <FormattedMessage {...subTitle} />
                        </div>
                    )}
                </div>

                <div styleName="message">
                    <FormattedMessage
                        {...message}
                        values={{
                            icon: iconMessage && (
                                <Icon
                                    styleName="message-icon"
                                    glyph={iconMessage}
                                />
                            ),
                            balance,
                        }}
                    />
                </div>

                <div styleName="footer ">
                    <div styleName="buttons">
                        <div styleName="cancel" onClick={handleCancel}>
                            <FormattedMessage {...cancelTextBtn} />
                        </div>
                        <div styleName="submit" onClick={handleSubmit}>
                            <FormattedMessage {...submitTextBtn} />
                        </div>
                    </div>
                    {isStakeBtn && (
                        <div styleName="sub-button" onClick={handleClick}>
                            <FormattedMessage
                                {...subTextBtn}
                                values={{ stake }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BetslipModal;
